import useHttpQuery from '@actions/services/firestore/browser/useHttpQuery';
import type { UseListFoldersParams, UseListFoldersResult, ListFoldersResponse } from './types';

const useListFolders = ({
    agentId,
    entityType,
    enabled = true,
}: UseListFoldersParams): UseListFoldersResult => {
    const queryParams = new URLSearchParams({ agentId, entityType });
    const pathname = `/folders?${queryParams.toString()}`;

    const { data, isLoading, error, refetch } = useHttpQuery<ListFoldersResponse>({
        pathname,
        method: 'GET',
        key: `folders-${agentId}-${entityType}`,
        queryOptions: { enabled },
    });

    return {
        folders: data?.data || [],
        isLoading,
        error: error || undefined,
        refetch,
    };
};

export default useListFolders;
